<template>
  <div class="d-flex flex-wrap">
    <v-select
      v-model.trim="v$.countryCode.$model"
      :items="translatedCountryCodes"
      item-title="text"
      :hint="t('components.phoneNumber.countryCode')"
      persistent-hint
      :error-messages="validationErrors(v$.countryCode.$errors)"
      required
      class="flex-grow-0 me-5"
    />
    <v-text-field
      v-model.trim="v$.phoneNumber.$model"
      type="number"
      :prefix="v$.countryCode.$model"
      :hint="t('components.phoneNumber.label')"
      persistent-hint
      :error-messages="validationErrors(v$.phoneNumber.$errors)"
      required
      class="no-inline-number-controls flex-grow-1"
    />
  </div>
</template>

<script setup lang="ts">
import { ErrorObject, useVuelidate } from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";
import { parsePhoneNumber } from "awesome-phonenumber";
import { ref, watch, onUpdated, computed } from "vue";
import { useI18n } from "vue-i18n";
import { phoneCountryCodes } from "@/utils/config";
import { requiredField } from "@/utils/custom-validators";

const { t } = useI18n();

const model = defineModel<string | undefined>();

const form = ref({
  countryCode: "+44",
  phoneNumber: "",
});
const translatedCountryCodes = computed(() =>
  phoneCountryCodes.map((code) => ({
    text: t(`components.phoneNumber.countryCodes.${code.value.replace("+", "")}`),
    value: code.value,
  })),
);
const v$ = useVuelidate(
  {
    countryCode: { requiredField },
    phoneNumber: {
      phoneNumberValidator: helpers.withMessage(
        t("components.phoneNumber.validation"),
        () => parsePhoneNumber(model.value ?? "").valid,
      ),
    },
  },
  form,
);
onUpdated(() => {
  if (model.value) {
    const phoneNumber = parsePhoneNumber(model.value);
    if (phoneNumber.valid) {
      form.value.countryCode = `+${phoneNumber.countryCode}`;
      form.value.phoneNumber = phoneNumber.number.significant;
    }
  }
});
watch(
  form,
  () => {
    if (!form.value.phoneNumber || form.value.phoneNumber === "") {
      model.value = undefined;
    } else {
      console.log(`${form.value.countryCode}${form.value.phoneNumber}`);
      model.value = `${form.value.countryCode}${form.value.phoneNumber}`;
    }
  },
  { deep: true },
);

const validationErrors = (errors: ErrorObject[]) => errors.map((e) => e.$message.toString());
</script>
